import request from "src/api/request-manager/gateway";

import type { GetFeatureStatusParams } from "./types/features-toggle.types";

const prefixURL = "/ffb-disbursement/api/v1";

const FeaturesToggleAPI = {
  getFeatureStatus(params: GetFeatureStatusParams = {}) {
    return request.get(`${prefixURL}/toggle-features/info`, params);
  }
};

const FeaturesToggleAPIPaths = {
  listFeatures: `${prefixURL}/toggle-features/info`
};

export default { ...FeaturesToggleAPIPaths, ...FeaturesToggleAPI };
